
import { UITextsService } from "@/api";
import {
    UITEXTS_FETCH,
    APP_SWITCH_LANGUAGE,
    NUGGET_RESET_NS
} from "@/store/actions.type";
import {
    FETCH_START,
    SET_UITEXTS,
    SET_APP_SWITCH_LANGUAGE,
    SET_LANGUAGE,
} from "@/store/mutations.type";

const state = () => ({
    isLoading: false,
    locale: {},
    language: window.siteHandle,
    languages: {},
    siteHandles: [
        'czechRepublicCzech',
        'croatiaCroatian',
        'denmarkDanish',
        'belgiumDutch',
        'finnlandFinnish',
        'turkeyTurkish',
        'hungaryHungarian',
        'belgiumFrench',
        'polandPolish',
        'portugalPortuguese',
        'switzerlandFrench',
        'spainSpanish',
        'ukraineUkrainian',
        'germanyGerman',
        'netherlandsDutch',
        'italyItalian',
        'sloveniaSlovenian',
        'swedenSwedish',
        'israelHebrew',
        'mexicoSpanish',
        'unitedKingdomEnglish',
        'switzerlandGerman',
        'irelandEnglish',
        'austriaGerman',
        'greeceGreek',
        'franceFrench',
        'switzerlandItalian',
        'slovakiaSlovak',
        'romaniaRomanian',
        'masterSpanish',
        'masterEnglish',
        'masterFrench',
        'masterGerman',
    ]
});

const actions = {

    async [UITEXTS_FETCH]({ commit, state }, force = false) {

        if (!force && (state.isLoading || (state.languages.hasOwnProperty(state.language) && !!Object.keys(state.languages[state.language]).length))) {
            return state;
        }

        commit(FETCH_START);

        window.setTimeout(async () => {
            const langData = await UITextsService.getLanguage();
            commit(SET_LANGUAGE, langData.data.handle);

            const textData = await UITextsService.getTexts();

            const result = {
                texts: textData.data,
                locale: langData.data
            };

            commit(SET_UITEXTS, result);

            return result;
        }, 0);

        return state;
    },

    async [APP_SWITCH_LANGUAGE]({ commit, dispatch }, language) {

        // await UITextsService.switchLanguage(language);
        localStorage.setItem('preflanguage', language);
        commit(SET_APP_SWITCH_LANGUAGE, language);
        dispatch(NUGGET_RESET_NS, null, { root: true });

        return await dispatch(UITEXTS_FETCH);
    },
};

const mutations = {

    [FETCH_START](state) {
        state.isLoading = true;
    },

    [SET_LANGUAGE](state, handle) {
        state.language = handle;
        localStorage.setItem('preflanguage', handle);
    },

    [SET_UITEXTS](state, { locale, texts }) {

        state.locale = locale;
        document.documentElement.setAttribute('lang', locale.bcp47);
        document.documentElement.setAttribute('dir', locale.dir);

        state.languages = {};
        state.languages[state.language] = texts.data.reduce((item, result) => {
            return {
                ...result,
                ...item
            }
        }, {});

        state.isLoading = false;
    },

    [SET_APP_SWITCH_LANGUAGE](state, language) {
        state.language = language;
    },
};

const getters = {
    isLoading: (state) => {
        return state.isLoading;
    },

    getActiveLanguage: (state) => {
        return state.language;
    },

    getLanguages: (state) => {
        return state.siteHandles;
    },

    t: (state) => (key) => {
        if (!state.languages.hasOwnProperty(state.language) || !state.languages[state.language].hasOwnProperty(key)) {
            return null;
        }

        return state.languages[state.language][key];
    }
};


export const uitexts = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
